export default __webpack_public_path__ + "static/media/temp-livraison.20dcc905.svg";